<template>
  <div class="navbar-wrapper">
    <div class="navbar-left">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb class="breadcrumb-container"></breadcrumb>
    </div>
    <div class="navbar-right">
      <el-tooltip content="全屏" placement="bottom">
        <span class="navbar-icon-btn" @click="toggleFullScreen">
          <svg-icon icon-class="fullscreen" />
        </span>
      </el-tooltip>
      <el-badge :value="3" class="navbar-badge">
        <span class="navbar-icon-btn">
          <i class="el-icon-bell"></i>
        </span>
      </el-badge>
      <language-switch />
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar || defaultAvatar">
          <span class="user-name">{{ name || '管理员' }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item>
            <router-link to="/" class="dropdown-link">
              <i class="el-icon-s-home"></i> 首页
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/ums" class="dropdown-link">
              <i class="el-icon-user-solid"></i> 个人中心
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" class="dropdown-link">
              <i class="el-icon-switch-button"></i> 退出登录
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LanguageSwitch from '@/components/LanguageSwitch/index.vue'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LanguageSwitch
  },
  data() {
    return {
      defaultAvatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSI4IiBmaWxsPSIjNDM2MWVlIi8+PHRleHQgeD0iMjAiIHk9IjI2IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9ImJvbGQiPkE8L3RleHQ+PC9zdmc+'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar-wrapper {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  padding: 0 20px;
  position: relative;
  z-index: 10;

  .navbar-left {
    display: flex;
    align-items: center;
    height: 100%;
    flex: 1;
  }

  .navbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 100%;
  }

  .hamburger-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 12px;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;

    &:hover {
      background: #f5f5f5;
    }
  }

  .breadcrumb-container {
    margin-left: 12px;
    display: flex;
    align-items: center;
  }

  .navbar-icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    color: #666;
    transition: all 0.3s;

    &:hover {
      background: #f0f2f5;
      color: #4361ee;
    }
  }

  .navbar-badge {
    margin-right: 4px;
  }

  .avatar-container {
    height: 56px;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 4px;
    border-radius: 8px;
    transition: all 0.3s;

    &:hover {
      background: #f5f5f5;
    }

    .avatar-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 12px 6px 6px;

      .user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        border: 2px solid #f0f0f0;
        object-fit: cover;
      }

      .user-name {
        font-size: 13px;
        color: #333;
        font-weight: 500;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .el-icon-arrow-down {
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
      }
    }
  }
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
  width: 100%;
  font-size: 13px;

  i {
    font-size: 14px;
    color: #666;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue